import { faUser, faCircleCheck, faHeart as faHeartRegular, faSave, faCreditCard, faAddressCard, faEdit } from '@fortawesome/free-regular-svg-icons';
import { faBasketShopping, faSearch, faBars, faEnvelope, faLock, faTimes, faHeart as faHeartSolid, faSlidersH, faTrash } from '@fortawesome/free-solid-svg-icons';
import { faChevronLeft, faChevronRight, faHeart, faCartShopping, faFilter } from '@fortawesome/free-solid-svg-icons';
import { library } from '@fortawesome/fontawesome-svg-core';

library.add(faChevronLeft, faChevronRight, faHeart, faUser, faCartShopping, faFilter, faBars);

export const icons = {
    user: faUser,
    heart: faHeartRegular,
    heartFull: faHeartSolid,
    cart: faBasketShopping,
    search: faSearch,
    edit: faEdit,
    hamburger: faBars,
    email: faEnvelope,
    lock: faLock,
    trash: faTrash,
    times: faTimes,
    save: faSave,
    creditCard: faCreditCard,
    idCard: faAddressCard,
    check: faCircleCheck,
    filter: faSlidersH,
    chevronLeft: faChevronLeft,
    chevronRight: faChevronRight,
    heart: faHeart,
    cart: faCartShopping,
    filter: faFilter,
    hamburger: faBars,
};